import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/navbar";
import { BrowserRouter, Routes, Route, Link, histo } from "react-router-dom";
import News from "./components/news/news";
import Data from "./components/results/data";
import Home from "./components/home/home";
import Partners from "./components/partners/partners";
import Contact from "./components/contact/contact";
import Footer from "./components/footer";
import Project from "./components/project/project";
import Events from "./components/news/events";
import NewsView from "./components/news/news_views";
import Information from "./components/results/information";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Cookies } from "react-cookie-consent";
import { Fragment, useRef, useState, useEffect } from "react";
import Privacy from "./components/privacy/privacy";
import { NavLink } from "react-router-dom";
import Login from "./components/login/login";
import "./components/style/active.css"
import "./components/style/loading.css"
import { MatomoProvider, createInstance, useMatomo } from '@datapunt/matomo-tracker-react'
import ReactGA from "react-ga4";
function App() {

  const [open, setOpen] = useState(false);
  useEffect(()=>{
    if(JSON.parse(localStorage.getItem("user"))==null){
      setOpen(true)
    }
  },[])
  const cancelButtonRef = useRef(null);
  var instance;
  function acceptCookies() {
    ReactGA.initialize("G-YBZ93T1J9B");
    instance = createInstance({
      urlBase: "https://webanalytics.italia.it/matomo/",
      siteId: 'YjpNLvG0G6',
      trackerUrl: "https://ingestion.webanalytics.italia.it/matomo.php", // optional, default value: `${urlBase}matomo.php`
      srcUrl: "https://ingestion.webanalytics.italia.it/matomo.js", // optional, default value: `${urlBase}matomo.js`
      linkTracking: true, // optional, default value: true
      
    });
  }
  function declineCookies() {
    Cookies.remove("_ga");
    Cookies.remove("_gat");
    Cookies.remove("_gid");
    Cookies.remove("_ga_YBZ93T1J9B")
  }

  return (
    <>

    <MatomoProvider value={instance}>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-opacity-90" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg w-full">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto basis-[10%] h-full md:w-full w-14 items-center justify-center rounded-full bg-[#C5D4D0] sm:mx-0 ">
                        <svg
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                         
                          className="h-14 w-14 "
                          viewBox="-11 -11 144 144"
                        fill="currentColor"
                        strokeLinecap=""
                          stroke="#80968A"
                        >
                          <g>
                            <path color='#80968A' d="M101.77,49.38c2.09,3.1,4.37,5.11,6.86,5.78c2.45,0.66,5.32,0.06,8.7-2.01c1.36-0.84,3.14-0.41,3.97,0.95 c0.28,0.46,0.42,0.96,0.43,1.47c0.13,1.4,0.21,2.82,0.24,4.26c0.03,1.46,0.02,2.91-0.05,4.35h0v0c0,0.13-0.01,0.26-0.03,0.38 c-0.91,16.72-8.47,31.51-20,41.93c-11.55,10.44-27.06,16.49-43.82,15.69v0.01h0c-0.13,0-0.26-0.01-0.38-0.03 c-16.72-0.91-31.51-8.47-41.93-20C5.31,90.61-0.73,75.1,0.07,58.34H0.07v0c0-0.13,0.01-0.26,0.03-0.38 C1,41.22,8.81,26.35,20.57,15.87C32.34,5.37,48.09-0.73,64.85,0.07V0.07h0c1.6,0,2.89,1.29,2.89,2.89c0,0.4-0.08,0.78-0.23,1.12 c-1.17,3.81-1.25,7.34-0.27,10.14c0.89,2.54,2.7,4.51,5.41,5.52c1.44,0.54,2.2,2.1,1.74,3.55l0.01,0 c-1.83,5.89-1.87,11.08-0.52,15.26c0.82,2.53,2.14,4.69,3.88,6.4c1.74,1.72,3.9,3,6.39,3.78c4.04,1.26,8.94,1.18,14.31-0.55 C99.73,47.78,101.08,48.3,101.77,49.38L101.77,49.38z M59.28,57.86c2.77,0,5.01,2.24,5.01,5.01c0,2.77-2.24,5.01-5.01,5.01 c-2.77,0-5.01-2.24-5.01-5.01C54.27,60.1,56.52,57.86,59.28,57.86L59.28,57.86z M37.56,78.49c3.37,0,6.11,2.73,6.11,6.11 s-2.73,6.11-6.11,6.11s-6.11-2.73-6.11-6.11S34.18,78.49,37.56,78.49L37.56,78.49z M50.72,31.75c2.65,0,4.79,2.14,4.79,4.79 c0,2.65-2.14,4.79-4.79,4.79c-2.65,0-4.79-2.14-4.79-4.79C45.93,33.89,48.08,31.75,50.72,31.75L50.72,31.75z M119.3,32.4 c1.98,0,3.58,1.6,3.58,3.58c0,1.98-1.6,3.58-3.58,3.58s-3.58-1.6-3.58-3.58C115.71,34.01,117.32,32.4,119.3,32.4L119.3,32.4z M93.62,22.91c2.98,0,5.39,2.41,5.39,5.39c0,2.98-2.41,5.39-5.39,5.39c-2.98,0-5.39-2.41-5.39-5.39 C88.23,25.33,90.64,22.91,93.62,22.91L93.62,22.91z M97.79,0.59c3.19,0,5.78,2.59,5.78,5.78c0,3.19-2.59,5.78-5.78,5.78 c-3.19,0-5.78-2.59-5.78-5.78C92.02,3.17,94.6,0.59,97.79,0.59L97.79,0.59z M76.73,80.63c4.43,0,8.03,3.59,8.03,8.03 c0,4.43-3.59,8.03-8.03,8.03s-8.03-3.59-8.03-8.03C68.7,84.22,72.29,80.63,76.73,80.63L76.73,80.63z M31.91,46.78 c4.8,0,8.69,3.89,8.69,8.69c0,4.8-3.89,8.69-8.69,8.69s-8.69-3.89-8.69-8.69C23.22,50.68,27.11,46.78,31.91,46.78L31.91,46.78z M107.13,60.74c-3.39-0.91-6.35-3.14-8.95-6.48c-5.78,1.52-11.16,1.41-15.76-0.02c-3.37-1.05-6.32-2.81-8.71-5.18 c-2.39-2.37-4.21-5.32-5.32-8.75c-1.51-4.66-1.69-10.2-0.18-16.32c-3.1-1.8-5.25-4.53-6.42-7.88c-1.06-3.05-1.28-6.59-0.61-10.35 C47.27,5.95,34.3,11.36,24.41,20.18C13.74,29.69,6.66,43.15,5.84,58.29l0,0.05v0h0l-0.01,0.13v0C5.07,73.72,10.55,87.82,20.02,98.3 c9.44,10.44,22.84,17.29,38,18.1l0.05,0h0v0l0.13,0.01h0c15.24,0.77,29.35-4.71,39.83-14.19c10.44-9.44,17.29-22.84,18.1-38l0-0.05 v0h0l0.01-0.13v0c0.07-1.34,0.09-2.64,0.06-3.91C112.98,61.34,109.96,61.51,107.13,60.74L107.13,60.74z M116.15,64.04L116.15,64.04 L116.15,64.04L116.15,64.04z M58.21,116.42L58.21,116.42L58.21,116.42L58.21,116.42z" />
                          </g>
                        </svg>
                      </div>
                      <div className="mt-3 basis-[90%] text-center sm:ml-4 sm:mt-0 sm:text-left grow">
                        <Dialog.Title
                          as="h3"
                          className="md:text-2xl text-lg font-semibold leading-6 text-gray-900"
                        >
                          This website uses cookies
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="md:text-lg text-base  text-gray-500">
                          The cookies used on this site are used to keep track of user activity on our site, in order to better improve the user experience.
                          <br></br><NavLink onClick={()=>{setOpen(false)}} to='/privacy' className=' mt-4  md:text-lg text-base font-normal text-blue-700 underline'>learn more</NavLink>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className="inline-flex w-full justify-center rounded-md bg-[#80968A] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#C5D4D0] hover:text-[#80968A] sm:ml-3 sm:w-auto"
                      onClick={() => {
                        setOpen(false);
                        declineCookies();
                      }}
                    >
                      Decline All
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-[#C5D4D0] px-3 py-2 text-sm font-semibold text-[#80968A] hover:bg-[#80968A] hover:text-white shadow-sm ring-1 ring-inset ring-gray-300  sm:mt-0 sm:w-auto"
                      onClick={() => {
                        setOpen(false);
                        acceptCookies();
                      }}
                      ref={cancelButtonRef}
                    >
                      Accept All
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/project/:id" element={<Project />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/Data" element={<Data />} />
        <Route path="/Information" element={<Information />} />
        <Route path="/news" element={<News />} />
        <Route path="/news_view/:id" element={<NewsView />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path='/login' element={<Login />} />
      </Routes>
      <Footer />
      </MatomoProvider>
    </>
  );
}

export default App;
